import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToggleWrapper from './styled';

class Toggle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.toggled
        };

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    static defaultProps = {
        toggled: false
    }

    handleOnChange() {
        this.setState({ checked: !this.state.checked }, () => {
            this.props.onChange(this.state.checked);
        });
    }

    render() {
        return (<ToggleWrapper>
            <input checked={this.state.checked} onChange={this.handleOnChange} type="checkbox" />
            <i />
        </ToggleWrapper>);
    }
}

Toggle.propTypes = {
    toggled: PropTypes.bool,
    onChange: PropTypes.func
};

export default Toggle;



// WEBPACK FOOTER //
// ./app/components/toggle/index.js